import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  identity: {
    cifConcession: '',
    vehicleId: '',
    vin: ''
  },
  componentsCMS: null,
  legalConditions: null,
  act: null,
  risk: null,
  checklists: null,
  errorIdentity: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
